// The pre-redesign pills used by TasksLegacy; delete together with it.
import { isToday, isPast, startOfDay } from "date-fns";

// The task-list filter tabs. Each tab has a `select(tasks)` returning the tasks it shows (from the
// same today's-tasks list), so its count and its list can't disagree. Kept in one place so the
// mappings are easy to adjust.
//
// `accent` drives the selected-pill styling. The leading status icon is mapped by key in TaskFilters.
const notCompleted = (t) => t.group !== "completed";
// A task is overdue when it was scheduled for a day before today (matching TaskCard's overdue flag).
export const isOverdue = (t) => t.due && !isToday(t.due) && isPast(startOfDay(t.due));

export const TASK_FILTERS = [
  {
    key: "today",
    label: "Today",
    accent: "zinc",
    select: (tasks) => tasks.filter((t) => notCompleted(t) && !!t.due && isToday(t.due)),
  },
  {
    key: "overdue",
    label: "Overdue",
    accent: "red",
    select: (tasks) => tasks.filter((t) => notCompleted(t) && isOverdue(t)),
  },
  {
    key: "cleared",
    label: "Cleared",
    accent: "green",
    select: (tasks) => tasks.filter((t) => t.group === "completed"),
  },
  {
    key: "all",
    label: "All",
    accent: "zinc",
    select: (tasks) => tasks.filter(notCompleted),
  },
];

export const DEFAULT_FILTER = "today";
